module.exports = __webpack_public_path__ + "static/media/Open.40abcab1.svg";